import {
  IconLink,
  IconAddressBook,
  IconWifi,
  IconMail,
  IconMessage,
  IconPhone,
  IconFileText,
  IconCalendarEvent,
  IconMapPin,
  IconDeviceMobile,
  IconQrcode,
} from '@tabler/icons-react';

interface QrCodeTypeIconProps {
  type: string;
  size?: number;
}

const TYPE_ICONS: Record<string, typeof IconLink> = {
  URL: IconLink,
  vCard: IconAddressBook,
  WiFi: IconWifi,
  Email: IconMail,
  SMS: IconMessage,
  Phone: IconPhone,
  Text: IconFileText,
  Event: IconCalendarEvent,
  Location: IconMapPin,
  AppStore: IconDeviceMobile,
};

export function QrCodeTypeIcon({ type, size = 16 }: QrCodeTypeIconProps) {
  const Icon = TYPE_ICONS[type] || IconQrcode;
  return <Icon size={size} />;
}
